// FMP liefert die Intraday-Kerzen-Zeitstempel als "YYYY-MM-DD HH:mm:ss" ohne
// Zeitzonen-Angabe, aber laut FMP-Doku in der Zeitzone der Boerse - fuer US-
// Symbole also America/New_York, nicht UTC oder Browser-Ortszeit. Ohne
// Umrechnung erschien die Chart-Uhrzeit faelschlich wie eine deutsche
// Ortszeit (z.B. Marktoeffnung 09:30 ET wurde als "09:30" statt "15:30"
// CEST angezeigt). Eigene Datei, damit sowohl MarketdataDetailPanel.js
// (Live-Kurse-Detail) als auch MarketdataChartTile.js (Charts-Modul) dieselbe
// Umrechnung nutzen, ohne sie zu duplizieren.

// Ermittelt den UTC-Offset einer Zeitzone zu einem gegebenen Zeitpunkt in
// Minuten (z.B. -240 fuer America/New_York waehrend EDT/Sommerzeit).
function getTimeZoneOffsetMinutes(timeZone, date) {
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone,
		hourCycle: 'h23',
		year: 'numeric', month: '2-digit', day: '2-digit',
		hour: '2-digit', minute: '2-digit', second: '2-digit',
	}).formatToParts(date).reduce((acc, part) => {
		acc[part.type] = part.value;
		return acc;
	}, {});
	const asUTC = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
	return (asUTC - date.getTime()) / 60000;
}

// dateString wird zunaechst als UTC geparst, nur um daraus naeherungsweise
// den America/New_York-Offset am selben Kalendertag zu bestimmen (fuer DST-
// Uebergaenge unerheblich genau genug). Der eigentliche Zahlenwert des
// Strings (z.B. "09:30") ist die NY-Ortszeit, also: echte UTC-Zeit = Zahlenwert
// minus NY-Offset. Das Ergebnis ist ein korrektes, zeitzonenunabhaengiges
// Date-Objekt - jede spaetere toLocaleTimeString()-Ausgabe zeigt dann
// automatisch die Browser-/Ortszeit.
export function parseExchangeTime(dateString) {
	const naiveUtc = new Date(dateString.replace(' ', 'T') + 'Z');
	const nyOffsetMinutes = getTimeZoneOffsetMinutes('America/New_York', naiveUtc);
	return new Date(naiveUtc.getTime() - nyOffsetMinutes * 60000);
}
